import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogOverlayModule } from '../dialog-overlay/dialog-overlay.module';
import { ChipsSelectorFormFieldModule } from '../ui-components/chips-selector-form-field/chips-selector-form-field.module';
import { JobTitleComponent } from './components/job-title.component';
import {  MatInputModule } from '@angular/material/input';
import { TextFieldModule } from '@angular/cdk/text-field';




@NgModule({
    declarations: [
        JobTitleComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DialogOverlayModule,
        ChipsSelectorFormFieldModule,
        MatInputModule,
        TextFieldModule,
    ],
    exports: [
        JobTitleComponent
    ],
})
export class JobTitleModule {
}
